import { useEffect, useState } from 'react';
import { DATABASE_CONNECTION } from './../content/constants';

export const useAuth0Params = () => {
  const [params, setParams] = useState(null);
 useEffect(() => {
    let config = JSON.parse(decodeURIComponent(escape(window.atob(window.config))));
    let leeway = config.internalOptions.leeway;
    if (leeway) {
      let convertedLeeway = parseInt(leeway);

      if (!isNaN(convertedLeeway)) {
        config.internalOptions.leeway = convertedLeeway;
      }
    }

    const params = Object.assign(
      {
        overrides: {
          __tenant: config.auth0Tenant,
          __token_issuer: config.authorizationServer.issuer,
        },
        connection: config?.connection || DATABASE_CONNECTION,
        domain: config.auth0Domain,
        clientID: config.clientID,
        redirectUri: config.callbackURL,
        responseType: 'code',
      },
      config.internalOptions
    );

    setParams(params);
  }, []);

  return params;
};
